import { globals } from 'config/globals';
import { Core } from 'core/Core';
import { distance, Point } from 'utils/math';
import { TimelineItemPath } from 'app/views/home/timeline/itemMotion/TimelineItemPath';
import { TimelineItemRepell } from 'app/views/home/timeline/itemMotion/TimelineItemRepell';
import { MouseController } from 'app/chrome/mouse/MouseController';
import { TimelineStateType } from 'app/views/home/timeline/timeline.types';
import { RelativeTimelinePosition } from 'app/views/home/timeline/RelativeTimelinePosition';

export class TimelineItemAttract {
	private _state: TimelineStateType = TimelineStateType.INTRO;
	private _distance: number; //Distance to mouse from Math helper
	private _distanceTolerence: number; //Distance to (randomly seeded to create partciles that will go furter to meet the mouse)
	private _distanceToTolerenceRatio: number; //The ratio of how close mouse is to limit
	private _baseEasePower: number; //Normal ease power when not effected by mouse proximity (Essentially the )
	private _attractEasePower: number; //Final ease power that takes into account the
	private _moveXTarget: number = 0;
	private _moveYTarget: number = 0;
	private _moveX: number = 0;
	private _moveY: number = 0;
	private _sprite: PIXI.Sprite;


	private _offsetTargetX: number = 0;
	private _offsetTargetY: number = 0;

	private _particlePathOrbit: TimelineItemPath;
	private _particlePathSine: TimelineItemPath;
	private _particleRepell: TimelineItemRepell;


	private _introActive: boolean = false;


	private _spacesTargetPosition: RelativeTimelinePosition;
	private _screensTargetPosition: RelativeTimelinePosition;

	public set introActive(v: boolean) {
		this._introActive = v;
	}

	public set buttonActive(v: boolean) {
	}

	constructor(
		sprite: PIXI.Sprite,
		particlePathOrbit: TimelineItemPath = null,
		particlePathSine: TimelineItemPath = null,
		particleRepell: TimelineItemRepell = null
	) {
		Core.controller.get('Mouse') as MouseController;
		this._sprite = sprite;
		this._particlePathOrbit = particlePathOrbit;
		this._particlePathSine = particlePathSine;
		this._particleRepell = particleRepell;

		0.8 + Math.random() * 0.9;
		this._baseEasePower = 2 + Math.random() * 2;

		//For hoz split:
		this._distanceTolerence = 500 + Math.random() * 500;
		//For vertical split:
		this._distanceTolerence = 1200 + Math.random() * 400;


		//Centered
		this._offsetTargetX = 0;
		this._offsetTargetY = 0;


		//When screens then target the logo:

		this._screensTargetPosition = new RelativeTimelinePosition(-0.05 + Math.random() * 0.22, 0.6 + Math.random() * 0.4);


		let y = (window as any).randomTriSeed ? 0.3 : 0.31;
		let x = (window as any).randomTriSeed ? 0.674 : 0.674;
		this._spacesTargetPosition = new RelativeTimelinePosition(x, y);
	}

	public resize(containerWidth: number, containerHeight: number): void {
		this._screensTargetPosition.resize(containerWidth, containerHeight);
		this._spacesTargetPosition.resize(containerWidth, containerHeight);
	}

	public tick(
		mouseCords: Point,
		absoluteX: number,
		containerX: number,
		absoluteY: number,
		mouseOffsetX: number,
		dragOffsetX: number
	): void {
		this._distance = distance(
			{ x: mouseCords.x + this._offsetTargetX, y: mouseCords.y + this._offsetTargetY },
			{ x: this._sprite.x, y: this._sprite.y }
		);

		this._distanceToTolerenceRatio = 0;

		let maxVelocity: number = this._state === TimelineStateType.HOME_LOGO_OVER ? 200 : 50;
		let easePower: number = 5;

		if (this._state === TimelineStateType.SPACES_TRANSITION) {
			maxVelocity = 100;
		} else if (this._state === TimelineStateType.SPACES) {
			maxVelocity = 1000;
			easePower = 15;
		}


		if (
			(this._distance < this._distanceTolerence && this._state === TimelineStateType.HOME_LOGO_OVER) ||
			this._state === TimelineStateType.SPACES_TRANSITION ||
			this._state === TimelineStateType.SPACES ||
			this._state === TimelineStateType.SCREENS
		) {
			if (this._particlePathOrbit) {
				this._particlePathOrbit.setActive(true);
			}

			if (this._particlePathSine) {
				this._particlePathSine.setActive(false);
			}

			this._particleRepell.setActive(true);

			this._distanceToTolerenceRatio = this._distance / this._distanceTolerence;
			if (this._distanceToTolerenceRatio > 1) {
				this._distanceToTolerenceRatio = 1;
			}

			// Reverse ratio:
			this._distanceToTolerenceRatio = 1 - this._distanceToTolerenceRatio;

			this._moveXTarget = mouseCords.x - (absoluteX + containerX) + this._offsetTargetX - mouseOffsetX - dragOffsetX;
			this._moveYTarget = mouseCords.y - absoluteY + this._offsetTargetY;

			if (this._state === TimelineStateType.SPACES) {
				//Update the target position based on the drag/mouse/effect offsets:
				this._spacesTargetPosition.update(
					containerX + this._offsetTargetX + mouseOffsetX + dragOffsetX,
					this._offsetTargetY
				);

				this._moveXTarget =
					this._spacesTargetPosition.x - (absoluteX + containerX) + this._offsetTargetX - mouseOffsetX - dragOffsetX;
				this._moveYTarget = this._spacesTargetPosition.y - absoluteY + this._offsetTargetY;
			}

			if (this._state === TimelineStateType.SCREENS) {
				this._screensTargetPosition.update(containerX + mouseOffsetX + dragOffsetX, this._offsetTargetY);

				this._moveXTarget =
					this._screensTargetPosition.x - (absoluteX + containerX) + this._offsetTargetX - mouseOffsetX - dragOffsetX;
				this._moveYTarget = this._screensTargetPosition.y - absoluteY - this._offsetTargetY;
			}

			if (globals.introActive && !this._introActive) {
				this._moveXTarget = 0;
				this._moveYTarget = 0;
			}
		} else {
			if (this._particlePathOrbit) {
				this._particlePathOrbit.setActive(false);
			}

			if (this._particlePathSine) {
				this._particlePathSine.setActive(true);
			}
			this._moveXTarget = 0;
			this._moveYTarget = 0;
		}

		this._attractEasePower = this._baseEasePower + easePower * this._distanceToTolerenceRatio;

		//Only allow so much velocity:


		if (this._moveXTarget - this._moveX > maxVelocity) {
			this._moveXTarget = this._moveX + maxVelocity;
		} else if (this._moveXTarget - this._moveX < -maxVelocity) {
			this._moveXTarget = this._moveX - maxVelocity;
		}

		if (this._moveYTarget - this._moveY > maxVelocity) {
			this._moveYTarget = this._moveY + maxVelocity;
		} else if (this._moveYTarget - this._moveY < -maxVelocity) {
			this._moveYTarget = this._moveY - maxVelocity;
		}

		this._moveX = this._moveX + (this._moveXTarget - this._moveX) / this._attractEasePower;
		this._moveY = this._moveY + (this._moveYTarget - this._moveY) / this._attractEasePower;
	}

	public getX() {
		return this._moveX;
	}

	public getY() {
		return this._moveY;
	}

	/** Set the timeline state for */
	public setTimelineState(state: TimelineStateType): void {
		this._state = state;
	}
}
